import { BorderRadiusSize, LessonType } from "./types";

export const LESSON_BORDER_RADIUS_SIZES: Partial<Record<LessonType, BorderRadiusSize>> = {
  [ LessonType.Video ]: BorderRadiusSize.M,
  [ LessonType.Audio ]: BorderRadiusSize.B,
  [ LessonType.Scorm ]: BorderRadiusSize.S,
  [ LessonType.Test ]: BorderRadiusSize.M,
  [ LessonType.Pdf ]: BorderRadiusSize.S,
  [ LessonType.Photo ]: BorderRadiusSize.M,
  [ LessonType.Photo2 ]: BorderRadiusSize.M,
  [ LessonType.Presentation ]: BorderRadiusSize.B,
  [ LessonType.Longread ]: BorderRadiusSize.M,
  [ LessonType.Longread2 ]: BorderRadiusSize.M,
  [ LessonType.Longread3 ]: BorderRadiusSize.M,
};

export const LESSON_MOBILE_BORDER_RADIUS_SIZES: Partial<Record<LessonType, BorderRadiusSize>> = {
  [ LessonType.Video ]: BorderRadiusSize.M,
  [ LessonType.Audio ]: BorderRadiusSize.B,
  [ LessonType.Scorm ]: BorderRadiusSize.M,
  [ LessonType.Test ]: BorderRadiusSize.M,
  [ LessonType.Pdf ]: BorderRadiusSize.S,
  [ LessonType.Photo ]: BorderRadiusSize.M,
  [ LessonType.Photo2 ]: BorderRadiusSize.M,
  [ LessonType.Presentation ]: BorderRadiusSize.B,
  [ LessonType.Longread ]: BorderRadiusSize.M,
  [ LessonType.Longread2 ]: BorderRadiusSize.M,
  [ LessonType.Longread3 ]: BorderRadiusSize.M,
};
